import * as React from "react";
import { SVGProps, memo } from "react";

const SvgClinic = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.157 5.814v-1h1.56v1h.97v1.5h-.97v1h-1.56v-1h-.97v-1.5h.97ZM5.257 9.81h1.5v1.5h-1.5v-1.5ZM6.757 13.041h-1.5v1.5h1.5v-1.5ZM9.237 9.81h1.5v1.5h-1.5v-1.5ZM10.737 13.041h-1.5v1.5h1.5v-1.5ZM13.216 9.81h1.5v1.5h-1.5v-1.5ZM14.716 13.041h-1.5v1.5h1.5v-1.5Z"
      fill="#637182"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.764 17.657h12.473a1.75 1.75 0 0 0 1.75-1.75V7.893a1.75 1.75 0 0 0-1.75-1.75h-1.694v-2.05a1.75 1.75 0 0 0-1.75-1.75H7.207a1.75 1.75 0 0 0-1.75 1.75v2.05H3.764a1.75 1.75 0 0 0-1.75 1.75v8.014c0 .966.783 1.75 1.75 1.75ZM7.207 3.843a.25.25 0 0 0-.25.25v3.55H3.764a.25.25 0 0 0-.25.25v8.014c0 .138.112.25.25.25h12.473a.25.25 0 0 0 .25-.25V7.893a.25.25 0 0 0-.25-.25h-3.194v-3.55a.25.25 0 0 0-.25-.25H7.207Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgClinic);

export default Memo;
